import React from "react";
import ForgotPasswordCard from "./components/ForgotPasswordCard";

function ForgotPasswordMain() {
  return (
    <section className="auth-main-page d-flex align-items-center justify-content-center">
      <ForgotPasswordCard />
    </section>
  );
}

export default ForgotPasswordMain;
